export const exportHeaders = [
    {
        label: "Member ID",
        key: "loyalty_id"
    },

    {
        label: "Billto",
        key: "customer_billto_account_number"
    },


    {
        label: "Customer Account Number",
        key: "customer_account_number"
    },

    {
        label: "Loyalty Start Date",
        key: "loyalty_start_date"
    },

    {
        label: "Loyalty End Date",
        key: "loyalty_end_date"
    },

    {
        label: "Status",
        key: "is_active"
    },

    
   


]